import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { init } from '../editorconfig';
import { ApiService } from '../../services/api.service';
import { environment } from '../../../environments/environment';
import { FileUpload } from 'primeng/fileupload';
import { UploadService } from '../../services/upload/upload.service';
import { getSqrDefaultContent } from '../../pre-ready-tepmlate';

@Component({
  selector: 'app-psqr',
  standalone: false,
  templateUrl: './psqr.component.html',
  styleUrl: './psqr.component.scss'
})
export class PsqrComponent implements OnInit, AfterViewInit {

  challengeForm!: FormGroup;
  commentForm!: FormGroup;
  proposalForm!: FormGroup;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  sqrEditorInit: EditorComponent['init'] = init;
  sqrDefaultContent: string = getSqrDefaultContent();

  @Input() proposalName: any;
  @Input() schemeType: any;
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() step: any;
  @Input() id: any;
  @Input() proposalId: any;

  @Output() generatePDFEmitter = new EventEmitter<any>();
  @Output() IRA = new EventEmitter<any>();
  @Output() routeConfig = new EventEmitter<any>();
  @Output() stepCompleted = new EventEmitter<void>();

  @ViewChild('fileUpload') fileUpload!: FileUpload;

  prototypeID: any;
  needGenData: any;
  apiUrl: string = environment.APIUrl;
  activePhaseId: any;
  userID: any;

  psqrSections = [
    { key: 'introduction', label: 'Introduction' },
    { key: 'essential_parameter_a', label: 'Essential Parameters A' },
    { key: 'operational_parameters', label: 'Section A Operational Parameters' },
    { key: 'technical_parameters', label: 'Section B Technical Parameters' },
    { key: 'maintainability_ergonomic_parameters', label: 'Section C Maintainability and Ergonomic Parameters' },
    { key: 'essential_parameter_b', label: 'Essential Parameters B' },
    { key: 'enhanced_performance_parameters', label: 'Enhanced Performance Parameters' }
  ];


  expandedSections = {
    additionalInfo: false,
    problemStatement: false,
    detailedInfo: false,
    uploads: false,
  };

  editorReady: boolean = false;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private uploadService: UploadService,
    private api: ApiService
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit(): void {
    // Initialize commentForm for SQR editor with default template
    // this.commentForm = this.fb.group({
    //   sqr_content: [this.sqrDefaultContent]
    // });
    this.challengeForm = this.fb.group({
      sqr_content: [this.sqrDefaultContent]
    });

    // Use snake_case form controls for makeI scheme, camelCase for others
    if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType)) {
      this.challengeForm = this.fb.group({
        ...this.psqrSections.reduce((acc, section) => ({
          ...acc,
          [section.key]: [section.key === 'introduction' ? this.sqrDefaultContent : '']
        }), {})
      });
    } else {
      this.challengeForm = this.fb.group({
        essentialParameters: [''],
        desirableParameters: [''],
        functionalRequirements: [''],
        performanceRequirements: [''],
        technicalRequirements: [''],
        operationalRequirements: [''],
        logisticalRequirements: [''],
        costRequirements: [''],
        timelineRequirements: [''],
        addRequirements: ['']
      });
    }
    this.challengeForm.disable();

    this.getProposalData();
    this.getPrototype();
    console.log("type", this.schemeType);
  }

  toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }

  ngAfterViewInit() {
    this.sqrEditorInit = {
      ...this.init,
      readonly: false,
      height: 600
    };
    setTimeout(() => {
      if (this.stepDetails?.can_edit) {
        this.isEditorDisabled = false;
        this.challengeForm.enable();
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      this.rebuildEditor();
    }, 3000);
  }

  rebuildEditor() {
    this.init = {
      ...this.init,
      readonly: false
    };
  }

  getProposalData() {
    const stepID = sessionStorage.getItem('needStepID');
    let url: string;
    if (this.schemeType === 'rev') {
      url = `/revenue/need-generation/?proposal_step=${stepID}&proposal_step__proposal=${this.proposalId}`;
    } else if (this.schemeType === 'tdf') {
      url = `/tdf/need-generation/?proposal_step__proposal=${this.proposalId}`;
    } else {
      url = `/make1/need-generation/?proposal_step__proposal=${this.proposalId}`;
    }
    this.api.getAPI(url).subscribe((res: any) => {
      this.needGenData = res[0];
    });
  }

  getFileName(url: string): string {
    const fileName = url?.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }

  onSubmit(): void {
    let formData: any;

    if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType)) {
      formData = {};
      // this.psqrSections.forEach(section => {
      //   formData[section.key] = this.challengeForm.get(section.key)?.value;
      // });
      formData['introduction'] = this.challengeForm.get('introduction')?.value || this.sqrDefaultContent;
      formData['proposal_step'] = this.id;
    } else {
      formData = new FormData();
      formData.append('proposal_step', this.id);
      formData.append('essential_parameter', this.challengeForm.get('essentialParameters')?.value);
      formData.append('desirable_parameter', this.challengeForm.get('desirableParameters')?.value);
      formData.append('functional_req', this.challengeForm.get('functionalRequirements')?.value);
      formData.append('performance_req', this.challengeForm.get('performanceRequirements')?.value);
      formData.append('technical_req', this.challengeForm.get('technicalRequirements')?.value);
      formData.append('operational_req', this.challengeForm.get('operationalRequirements')?.value);
      formData.append('logistical_req', this.challengeForm.get('logisticalRequirements')?.value);
      formData.append('cost_req', this.challengeForm.get('costRequirements')?.value);
      formData.append('timeline_req', this.challengeForm.get('timelineRequirements')?.value);
      formData.append('additonal_req', this.challengeForm.get('addRequirements')?.value);
    }

    if (this.prototypeID) {
      this.api.putAPI(`/make1/psqr/${this.prototypeID}/`, formData).subscribe((res: any) => {
        if (res) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Form saved sucessfully'
          });
          this.getPrototype();
        }
      });
    } else {
      this.api.postAPI(`/make1/psqr/`, formData).subscribe((res: any) => {
        if (res) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Data saved successfully'
          });
          this.getPrototype();
        }
      });
    }
  }

  getPrototype() {
    this.api.getAPI(`/make1/psqr/?proposal_step__proposal=${this.proposalId}`).subscribe((res: any) => {
      this.prototypeID = res[0]?.id;

      // Use correct form control names based on scheme type
      if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType)) {
        this.challengeForm.patchValue({
          ...res[0],
          introduction: res[0]?.introduction || this.sqrDefaultContent
        });
      } else {
        this.challengeForm.patchValue({
          essentialParameters: res[0]?.essential_parameter,
          desirableParameters: res[0]?.desirable_parameter,
          functionalRequirements: res[0]?.functional_req,
          performanceRequirements: res[0]?.performance_req,
          technicalRequirements: res[0]?.technical_req,
          operationalRequirements: res[0]?.operational_req,
          logisticalRequirements: res[0]?.logistical_req,
          costRequirements: res[0]?.cost_req,
          timelineRequirements: res[0]?.timeline_req,
          addRequirements: res[0]?.additonal_req,
          introduction: res[0]?.introduction ? res[0].introduction : getSqrDefaultContent(),
        });
      }
    });
  }

  generatePDF() {
    // Get form control names based on scheme type
    const essentialParam = this.schemeType === 'makeI' ? 'essential_parameter' : 'essentialParameters';
    const desirableParam = this.schemeType === 'makeI' ? 'desirable_parameter' : 'desirableParameters';
    const functionalReq = this.schemeType === 'makeI' ? 'functional_req' : 'functionalRequirements';
    const performanceReq = this.schemeType === 'makeI' ? 'performance_req' : 'performanceRequirements';
    const technicalReq = this.schemeType === 'makeI' ? 'technical_req' : 'technicalRequirements';
    const operationalReq = this.schemeType === 'makeI' ? 'operational_req' : 'operationalRequirements';
    const logisticalReq = this.schemeType === 'makeI' ? 'logistical_req' : 'logisticalRequirements';
    const costReq = this.schemeType === 'makeI' ? 'cost_req' : 'costRequirements';
    const timelineReq = this.schemeType === 'makeI' ? 'timeline_req' : 'timelineRequirements';
    const additionalReq = this.schemeType === 'makeI' ? 'additonal_req' : 'addRequirements';

    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.proposalName },
        { key: "Essential Parameters", value: this.challengeForm.get(essentialParam)?.value },
        { key: "Desirable Parameters", value: this.challengeForm.get(desirableParam)?.value },
        { key: "Functional Requirements", value: this.challengeForm.get(functionalReq)?.value },
        { key: "Performance Requirements", value: this.challengeForm.get(performanceReq)?.value },
        { key: "Technical Requirements", value: this.challengeForm.get(technicalReq)?.value },
        { key: "Operational Requirements", value: this.challengeForm.get(operationalReq)?.value },
        { key: "Logistical Requirements", value: this.challengeForm.get(logisticalReq)?.value },
        { key: "Cost Requirements", value: this.challengeForm.get(costReq)?.value },
        { key: "Timeline Requirements", value: this.challengeForm.get(timelineReq)?.value },
        { key: "Additional Requirements", value: this.challengeForm.get(additionalReq)?.value }
      ]
    };

    this.generatePDFEmitter.emit(payload);
  }

  // printForm(): void {
  //   let printData: { label: string; value: string }[] = [];

  //   printData.push({ label: 'Proposal Name', value: this.proposalName || '-' });

  //   if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType)) {
  //     this.psqrSections.forEach(section => {
  //       printData.push({
  //         label: section.label,
  //         value: this.challengeForm.get(section.key)?.value || '-'
  //       });
  //     });
  //   } else {
  //     const fields = [
  //       { label: 'Essential Parameters', ctrl: 'essentialParameters' },
  //       { label: 'Desirable Parameters', ctrl: 'desirableParameters' },
  //       { label: 'Functional Requirements', ctrl: 'functionalRequirements' },
  //       { label: 'Performance Requirements', ctrl: 'performanceRequirements' },
  //       { label: 'Technical Requirements', ctrl: 'technicalRequirements' },
  //       { label: 'Operational Requirements', ctrl: 'operationalRequirements' },
  //       { label: 'Logistical Requirements', ctrl: 'logisticalRequirements' },
  //       { label: 'Cost Requirements', ctrl: 'costRequirements' },
  //       { label: 'Timeline Requirements', ctrl: 'timelineRequirements' },
  //       { label: 'Additional Requirements', ctrl: 'addRequirements' }
  //     ];
  //     fields.forEach(field => {
  //       printData.push({
  //         label: field.label,
  //         value: this.challengeForm.get(field.ctrl)?.value || '-'
  //       });
  //     });
  //   }

  //   // Build table rows
  //   const tableRows = printData
  //     .map(
  //       (item, index) => `
  //       <tr>
  //         <td style="padding:10px 14px; border:1px solid #cbd5e1; font-weight:600; color:#334155; background:#f8fafc; width:40px; text-align:center;">${index + 1}</td>
  //         <td style="padding:10px 14px; border:1px solid #cbd5e1; font-weight:600; color:#1e40af; background:#f8fafc; width:250px; vertical-align:top;">${item.label}</td>
  //         <td style="padding:10px 14px; border:1px solid #cbd5e1; color:#334155;">${item.value}</td>
  //       </tr>`
  //     )
  //     .join('');

  //   const printHtml = `
  //     <html>
  //       <head>
  //         <title>PSQR - ${this.proposalName || 'Form Data'}</title>
  //         <style>
  //           @media print {
  //             body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  //             .no-print { display: none !important; }
  //           }
  //           body { font-family: 'Segoe UI', Arial, sans-serif; margin: 20px; color: #1e293b; }
  //           h2 { text-align: center; color: #1e3a5f; margin-bottom: 4px; }
  //           h4 { text-align: center; color: #2563eb; margin-top: 0; margin-bottom: 20px; font-weight: 500; }
  //           table { width: 100%; border-collapse: collapse; }
  //           th { padding: 12px 14px; border: 1px solid #94a3b8; background: #1e40af; color: #fff; text-align: left; font-size: 14px; }
  //           .btn-print { display:block; margin:20px auto; padding:10px 32px; background:#1e40af; color:#fff; border:none; border-radius:6px; font-size:15px; cursor:pointer; }
  //           .btn-print:hover { background:#1e3a8a; }
  //         </style>
  //       </head>
  //       <body>
  //         <h2>${this.stepDetails?.name || 'PSQR'}</h2>
  //         <h4>[${this.proposalName || ''}]</h4>
  //         <table>
  //           <thead>
  //             <tr>
  //               <th style="width:40px; text-align:center;">S.No</th>
  //               <th style="width:250px;">Field</th>
  //               <th>Value</th>
  //             </tr>
  //           </thead>
  //           <tbody>
  //             ${tableRows}
  //           </tbody>
  //         </table>
  //         <button class="btn-print no-print" onclick="window.print()">🖨️ Print</button>
  //       </body>
  //     </html>
  //   `;

  //   const printWindow = window.open('', '_blank', 'width=900,height=700');
  //   if (printWindow) {
  //     printWindow.document.write(printHtml);
  //     printWindow.document.close();
  //   }
  // }

}
